<template>
    <div>
        <v-select
            ref="vselect"
            :options="entityOptions"
            :filterable="false"
            @search="onSearch"
            @input="onChange"
            v-bind="$attrs"
            v-on="$listeners"
            :value="value"
            :searchable="true"
            @search:blur="setSearchText"
        >
            <template slot="no-options">
                <span v-if="search_text.length < 2">Type to search</span>
                <span v-else-if="!isLoading">No matches found</span>
                <span v-else-if="isLoading">
                    Loading...
                </span>
                <span v-else></span>
            </template>
            <template #selected-option="{ fullname }">
                <div style="display: flex; align-items: baseline;">
                    {{ fullname }}
                </div>
            </template>
            <template #list-header>
                <div class="menu">
                    <a
                        v-if="
                            showAddContact &&
                            _hasAccess('contact.person.create')
                        "
                        @click.stop="addContact"
                        class="badge badge-success rounded-0 cursor-pointer mr-2"
                        >Add Contact</a
                    >
                    <a
                        v-if="
                            showAddCompany &&
                            _hasAccess('contact.company.create')
                        "
                        @click.stop="addCompany"
                        class="badge badge-success rounded-0 cursor-pointer mr-2"
                        >Add Company</a
                    >
                    <!-- TODO : to confirm this permission -->
                    <a
                        v-if="
                            showAddPatient &&
                            _hasAccess('patient.profile.create')
                        "
                        @click="addPatient"
                        class="badge badge-success rounded-0 cursor-pointer mr-2"
                        >Add Patient</a
                    >
                </div>
            </template>
            <div slot="option" slot-scope="{ fullname }">
                <span>{{ fullname }}</span>
            </div>
        </v-select>
        <NewContact ref="newContactWindow" @saved="onChange"></NewContact>
        <NewCompany ref="newCompanyWindow" @saved="onChange"></NewCompany>
        <NewPatient
            :showAddNew="false"
            ref="newPatientWindow"
            @saved="savedPatient"
        ></NewPatient>
    </div>
</template>
<script>
import { debounce, get } from "lodash";
import NewContact from "@/components/contact-actor/new-modal";
import NewCompany from "@/components/contact-company/new-modal";
import NewPatient from "@/module/commons/patient/modal.vue";
import * as humanparser from "humanparser";
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
        NewContact,
        NewCompany,
        NewPatient
    },
    props: {
        contactType: {
            type: String
        },
        relationType: {
            Number,
            required: true,
            validator: function (prop) {
                return typeof prop === "number" || prop === null || prop;
            }
        },
        showAddContact: {
            type: Boolean,
            default: true
        },
        showAddCompany: {
            type: Boolean,
            default: true
        },
        showAddPatient: {
            type: Boolean,
            default: false
        },
        value: [Object, String, Array, Number]
    },
    data() {
        return {
            search_text: "",
            entityOptions: [],
            isLoading: false
        };
    },
    methods: {
        onSearch(value, loading) {
            this.search_text = value;
            if (value.length > 2) {
                this.isLoading = true;
                this.query = value;

                if (value === "") {
                    this.isLoading = false;
                    this.entityOptions = [];
                    return;
                }

                this.fetchOptions(value, this, loading);
            }
        },
        fetchOptions: debounce(async (value, self, loading) => {
            loading(true);
            const SEARCH_URI = `${process.env.BARRAMUNDI}actor/filter-contacts-patients`;
            const res = await self.$http.get(SEARCH_URI, {
                params: {
                    search_key: value,
                    relation: self.relationType,
                    contact_type: self.contactType
                }
            });

            const { message, resources } = res.data.response;

            if (message.code === 200) {
                self.entityOptions = resources.results;
            } else {
                self.entityOptions = [];
            }

            loading(false);
            self.isLoading = false;
            // await self.registerFootLoader();
        }, 350),
        onChange(value) {
            this.$emit("input", value);
        },
        savedPatient(value) {
            let patient = value;

            patient.contact_type = "patient";
            patient.fullname = value.name;

            this.$emit("input", patient);
        },
        // Defocus will lost the current text, save it to somewhere else.
        setSearchText(event) {
            this.txt = this.search_text;
            this.$emit("search:blur", event);
        },
        preventFocus() {
            let self = this;
            this.$root.$once("bv::modal::hidden", () => {
                self.$nextTick(() => {
                    self.$nextTick(() => {
                        $(self.$refs.vselect.$el).find("input").blur();
                    });
                });
            });
        },
        addContact() {
            if (this.search_text) {
                let name = humanparser.parseName(this.search_text);
                this.$refs.newContactWindow.open({
                    firstname: name.firstName,
                    lastname: [name.middleName, name.lastName, name.suffix]
                        .join(" ")
                        .trim()
                });
            } else {
                this.$refs.newContactWindow.open({
                    firstname: "",
                    lastname: ""
                });
            }
            this.preventFocus();
        },
        addCompany() {
            if (this.search_text) {
                let name = humanparser.parseName(this.search_text);
                this.$refs.newCompanyWindow.open({
                    name: [
                        name.firstName,
                        name.middleName,
                        name.lastName,
                        name.suffix
                    ]
                        .filter(Boolean) // to remove undefined/null value
                        .join(" ")
                        .trim()
                });
            } else {
                this.$refs.newCompanyWindow.open({
                    name: []
                });
            }
            this.preventFocus();
        },
        addPatient() {
            if (get(this, "subscription.patient_status") === 1) {
                this._message(this.subscription.patient_message, "warning");
            } else {
                this.$refs.newPatientWindow.open({
                    name: this.search_text
                });
            }
            this.preventFocus();
        }
    }
};
</script>
